module.exports = __webpack_public_path__ + "img/frame (194).5292419a.jpg";